const CheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.56649 11.5C5.38849 11.5 5.2105 11.434 5.07422 11.2993L0.204415 6.48588C-0.0681384 6.21648 -0.0681384 5.78214 0.204415 5.51274C0.476969 5.24335 0.916391 5.24335 1.18894 5.51274L5.56649 9.83962L14.8111 0.702049C15.0836 0.43265 15.523 0.43265 15.7956 0.702049C16.0681 0.971448 16.0681 1.40579 15.7956 1.67518L6.05597 11.2993C5.91969 11.434 5.7417 11.5 5.56371 11.5H5.56649Z"
      fill="#1A1A1A"
    />
    <path
      d="M5.56649 11.5C5.38849 11.5 5.2105 11.434 5.07422 11.2993L0.204415 6.48588C-0.0681384 6.21648 -0.0681384 5.78214 0.204415 5.51274C0.476969 5.24335 0.916391 5.24335 1.18894 5.51274L5.56649 9.83962L14.8111 0.702049C15.0836 0.43265 15.523 0.43265 15.7956 0.702049C16.0681 0.971448 16.0681 1.40579 15.7956 1.67518L6.05597 11.2993C5.91969 11.434 5.7417 11.5 5.56371 11.5H5.56649Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M5.56649 11.5C5.38849 11.5 5.2105 11.434 5.07422 11.2993L0.204415 6.48588C-0.0681384 6.21648 -0.0681384 5.78214 0.204415 5.51274C0.476969 5.24335 0.916391 5.24335 1.18894 5.51274L5.56649 9.83962L14.8111 0.702049C15.0836 0.43265 15.523 0.43265 15.7956 0.702049C16.0681 0.971448 16.0681 1.40579 15.7956 1.67518L6.05597 11.2993C5.91969 11.434 5.7417 11.5 5.56371 11.5H5.56649Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M5.56649 11.5C5.38849 11.5 5.2105 11.434 5.07422 11.2993L0.204415 6.48588C-0.0681384 6.21648 -0.0681384 5.78214 0.204415 5.51274C0.476969 5.24335 0.916391 5.24335 1.18894 5.51274L5.56649 9.83962L14.8111 0.702049C15.0836 0.43265 15.523 0.43265 15.7956 0.702049C16.0681 0.971448 16.0681 1.40579 15.7956 1.67518L6.05597 11.2993C5.91969 11.434 5.7417 11.5 5.56371 11.5H5.56649Z"
      fill="black"
      fill-opacity="0.2"
    />
  </svg>
);

export default CheckIcon;
